import React, { useState, useEffect } from 'react';
import { Table, Space, DatePicker, Tag, Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
const { RangePicker } = DatePicker;
import Highlighter from 'react-highlight-words';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import UserStatus from '../../data/UserStatus';

const SignupUserAnalytics = ({ signupStats, fetchSignupStats }) => {
	const [searchText, setSearchText] = useState('');
	const [searchedColumn, setSearchedColumn] = useState('');

	const getColumnSearchProps = (dataIndex) => ({
		filterDropdown: function filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
			return (
				<div style={{ padding: 8 }}>
					<Input
						placeholder={`Search ${dataIndex}`}
						value={selectedKeys[0]}
						onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
						onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
						style={{ width: 188, marginBottom: 8, display: 'block' }}
					/>
					<Space>
						<Button
							type="primary"
							onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
							icon={<SearchOutlined />}
							size="small"
							style={{ width: 90 }}
						>
							Search
						</Button>
						<Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
							Reset
						</Button>
					</Space>
				</div>
			);
		},
		filterIcon: function filter(filtered) {
			return <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />;
		},
		onFilter: (value, record) =>
			record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
		render: function render(text) {
			return searchedColumn === dataIndex ? (
				<Highlighter
					highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
					searchWords={[searchText]}
					autoEscape
					textToHighlight={text ? text.toString() : ''}
				/>
			) : (
				text
			);
		},
	});

	const handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	};

	const handleReset = (clearFilters) => {
		clearFilters();
		setSearchText('');
	};

	const columns = [
		{
			title: 'Full Name',
			key: 'fullName',
			sorter: (a, b) => a.fullName.length - b.fullName.length,
			...getColumnSearchProps('fullName'),
			render: function action(text, record) {
				return (
					<div>
						<a
							href={`https://carmandee.com/profile/${record.type}/${record.username}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							<p key={record?.fullName}>{record?.fullName}</p>
						</a>
					</div>
				);
			},
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
			...getColumnSearchProps('email'),
		},
		{
			title: 'Phone',
			dataIndex: 'phone',
			key: 'phone',
			...getColumnSearchProps('phone'),
		},
		{
			title: 'Signup Info',
			key: 'createdAt',
			render: function action(text, record) {
				return (
					<p key={record?.createdAt}>
						{' '}
						{new Date(record?.createdAt).toLocaleDateString()} {new Date(record?.createdAt).toLocaleTimeString()}{' '}
					</p>
				);
			},
		},
		{
			title: 'User Level',
			dataIndex: ['userLevel', 'name'],
		},
		{
			title: 'Type',
			dataIndex: 'type',
			key: 'type',
			sorter: (a, b) => a.type?.length - b.type?.length,
			render: function type(text, record) {
				return <>{record.type === 'seller' ? <Tag color="warning">Seller</Tag> : <Tag color="green">Dealer</Tag>}</>;
			},
		},
		{
			title: 'Status Action',
			key: 'status',
			render: function status(text, record) {
				return (
					<>
						{record?.status === UserStatus.ACTIVE && <Tag color="green">Approved</Tag>}
						{record?.status === UserStatus.PENDING_VERIFICATION && <Tag color="yellow">Pending Verification</Tag>}
						{record?.status === UserStatus.SUSPENDED && <Tag color="warning">Suspended</Tag>}
						{record?.status === UserStatus.DELETED && <Tag color="red">DELETED</Tag>}
					</>
				);
			},
		},
	];

	return (
		<div className="page">
			<div className="center-div">
				<h3>Select Range</h3>
				<Space direction="vertical" size={12}>
					<RangePicker
						showTime
						onOk={(value) => {
							fetchSignupStats(value);
						}}
					/>
				</Space>
			</div>
			<div className="center-div">
				<h3>Number of Users : {signupStats?.length}</h3>
			</div>
			<div>
				<Table
					dataSource={signupStats}
					columns={columns}
					rowKey={(record) => record._id}
					size="small"
					scroll={{ x: true }}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	signupStats: state.signupStats.signupStats,
});

const mapDispatchToProps = (dispatch) => ({
	fetchSignupStats: (value) => dispatch(Actions.fetchSignupStats(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupUserAnalytics);
